<template>
  <label class="m-0 px-4 py-3 flex gap-2 items-center cursor-text" :for="`${name}-search`">
    <FontAwesomeIcon class="flex-shrink-0" icon="magnifying-glass" :class="value ? 'text-current' : 'text-gray-400'" />
    <input
      :id="`${name}-search`"
      type="search"
      class="bg-transparent placeholder-gray-400 p-0 border-none ring-0 outline-none focus:border-none focus:outline-none focus:ring-0 flex-grow min-w-0 text-current"
      :placeholder="placeholder"
      :value="value"
      :disabled="disabled"
      @input="$emit('input', (<HTMLInputElement>$event.target).value)"
    />
    <XIcon v-if="value" class="w-4 h-4 text-white cursor-pointer flex-shrink-0" @click="$emit('input', '')" />
  </label>
</template>

<script lang="ts" setup>
import XIcon from '@/components/icons/x.svg'

defineProps({
  name: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: 'Search by Keyword',
  },
})

defineEmits(['input'])
</script>

<style lang="stylus" scoped>
input:empty
  @apply whitespace-nowrap overflow-ellipsis overflow-hidden
</style>
